/** Workday column header: a compact date per calendar day, Monday-emphasized so
 *  the week rhythm reads at a glance, zone corner. */
import React from "react";
import { DAY_PX, ZONE_LABEL_WIDTH } from "../helpers";

const DayHeader: React.FC<{
  calendar: string[];
  corner?: React.ReactNode;
  labelWidth?: number;
  /** Relative scale: show DAY 0, 1, 2… instead of calendar dates (the train is a
   *  level-agnostic template, so it reads in relative days, not real dates). */
  relative?: boolean;
}> = ({ calendar, corner, labelWidth = ZONE_LABEL_WIDTH, relative = false }) => (
  <div className="pull-plan-grid-day-header">
    <div className="pull-plan-grid-day-corner" style={{ width: labelWidth }}>
      {corner}
    </div>
    {calendar.map((iso, i) => {
      const d = new Date(iso + "T00:00:00");
      const dateLabel = d.toLocaleDateString(undefined, { month: "numeric", day: "numeric" });
      const isMonday = d.getDay() === 1;
      return (
        <div
          key={relative ? i : iso}
          className={`pull-plan-grid-day ${!relative && isMonday && i > 0 ? "week-start" : ""}`}
          style={{ width: DAY_PX }}
        >
          <div className="pull-plan-grid-day-date">{relative ? i : dateLabel}</div>
        </div>
      );
    })}
  </div>
);
export default DayHeader;
